import { render, staticRenderFns } from "./BigButtons.vue?vue&type=template&id=e384a148&scoped=true&"
import script from "./BigButtons.vue?vue&type=script&lang=js&"
export * from "./BigButtons.vue?vue&type=script&lang=js&"
import style0 from "./BigButtons.vue?vue&type=style&index=0&id=e384a148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384a148",
  null
  
)

export default component.exports